module.exports = __webpack_public_path__ + "static/media/share-desktop_light.fd9506de.svg";